import { Flex } from '@chakra-ui/react'

export default function StaticAudioViewer({
  fileUrl,
}: {
  fileUrl: string
  [key: string]: unknown
}) {
  return (
    <Flex height="100%" align="center" justify="center">
      {/* biome-ignore lint/a11y/useMediaCaption: published audio supplies captions only when present in the source media. */}
      <audio src={fileUrl} controls autoPlay />
    </Flex>
  )
}
